import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={10}
      height={10}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M6.315 2.202a.535.535 0 11-1.034-.277.535.535 0 011.034.277zM5.029 7l.843-3.144c.155-.582-.738-.822-1.315-.543-.361.175-.668.443-.89.777.363-.16 1.173-.52.878.58l-.842 3.143c-.156.582.737.822 1.315.543.36-.175.668-.443.89-.777-.363.16-1.174.52-.879-.58zM10 5A5 5 0 110 5a5 5 0 0110 0zm-.555 0a4.444 4.444 0 10-8.89 0 4.444 4.444 0 008.89 0z"
        fill="#333"
      />
    </Svg>
  );
}

export default SvgComponent;
